import {
  firebase,
  createFirebaseWrapper,
  FunctionCall,
} from "./firebaseWrapper";
// firebase is loaded from seperate script tags
// so we just import the type here
const firebaseInstance = (window as { firebase: firebase }).firebase;
if (window.location.hostname === "localhost") {
  // var firebaseConfig = {
  //   // Point to the RTDB emulator running on localhost.
  //   // In almost all cases the ns (namespace) is your project ID.
  //   databaseURL: "http://localhost:9000?ns=YOUR_DATABASE_NAMESPACE"
  // }
  // firebase.initializeApp(firebaseConfig);
  firebaseInstance.functions().useFunctionsEmulator("http://localhost:5001");
}
export default createFirebaseWrapper(firebaseInstance);
export type { FunctionCall };
